<template>
  <van-button round block type="primary" class="nowrap" @click="sendsms" v-if="time<=0">{{title}}</van-button>
  <van-button round block type="primary" class="nowrap" v-else>等待{{time}}s</van-button>
</template>

<script>
// import { showToast } from 'vant'
export default {
  name: 'SendSms',
  data () {
    return {
      time: 0,
      title: '获取验证码'
    }
  },
  props: {
    mobile: String, typeid: { type: Number, default: 1 }  //1-登录 2-注册 3-忘记密码
  },
  methods: {
    sendsms () {
      this.ajax.post("api/sendsms", { mobile: this.mobile, typeid: this.typeid }).then(() => {
        console.log('res');
        // console.log(res);
        // if (res.data.errcode == 0) {
        //   showToast({
        //     message: (res.data.message)
        //   })
        //   return
        // }
        this.time = 60;
        this.$store.state.timer = setInterval(() => {
          this.time--;
          if (this.time == 0) {
            clearInterval(this.$store.state.timer);
            this.title = '再次获取';
          }
        }, 1000)
      })
    }
  },
  mounted () {
    if (this.$store.state.timer) {
      clearInterval(this.$store.state.timer);
      clearTimeout(this.$store.state.timer);
      this.$store.state.timer = null;
    }
  }
}
</script>

<style>
</style>
